import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../common/actions';
// report-common
import { getReportReducers } from '../../report-common';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature carrier
import * as A from './actions';
import * as LC from './constants';
//////////////////////////////////////////////////

const initial = {
  activeTab: 'general',
  activePage: 'general',
  showTrackingSynchronization: false,
};

const {
  setReports,
  selectItem,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemSuccess,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
  setInitialStateOmitReport,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers(initial);

const setActiveTab = (state, tab) => (
  P.$set('activeTab', R.or(tab.tabName, tab), state)
);

const setActivePage = (state, page) => (
  P.$set('activePage', page, state)
);

const receivedCarrierOnboardingPackageSuccess = (state, data) => (
  P.$set('sendPackage', data, state)
);

const sendCarrierListToIntegrationSuccess = (state, data) => P.$set(
  'itemList',
  R.map(
    (entity) => {
      const guid = G.getGuidFromObject(entity);
      const branches = R.pathOr(null, [guid], data);

      if (R.isNil(branches)) return entity;

      return R.assoc(GC.GRC.INTEGRATION_INFO_EXTERNAL_DIVISION_NAME, R.prop(guid, data), entity);
    },
    state.itemList,
  ),
  state,
);

const getDispatchIntegrationConfigListSuccess = (state, data) => {
  const showTrackingSynchronization = R.any(
    R.propEq(GC.DISPATCH_INTEGRATION_TYPE_MACRO_POINT, GC.FIELD_TYPE),
    R.or(data, []),
  );

  return P.$set('showTrackingSynchronization', showTrackingSynchronization, state);
};

export default createReducer({
  // report common
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setUsedReport]: setUsedReport,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.deleteItemSuccess]: deleteItemSuccess,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.setInitialStateOmitReport]: setInitialStateOmitReport,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
  // report common
  [A.setActiveTab]: setActiveTab,
  [A.setActivePage]: setActivePage,
  [A.sendCarrierListToIntegrationSuccess]: sendCarrierListToIntegrationSuccess,
  [A.receivedCarrierOnboardingPackageSuccess]: receivedCarrierOnboardingPackageSuccess,
  // carrier tracking synchronization
  [A.getDispatchIntegrationConfigListSuccess]: getDispatchIntegrationConfigListSuccess,
}, initialState);
